import { render, staticRenderFns } from "./Guichets.vue?vue&type=template&id=96bcc4b0&"
import script from "./Guichets.vue?vue&type=script&lang=js&"
export * from "./Guichets.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports